import Header from "./Header";
import Footer from "./Footer";
import { Outlet } from "react-router-dom";
import { IconButton } from "@mui/material";
import ArrowDropUpIcon from "@mui/icons-material/ArrowDropUp";
import useScrollHelper from "../hooks/useScrollHelper";

const BaseLayout = () => {
  const { scrollToTop } = useScrollHelper();
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
        minHeight: "100vh",
        position: "relative",
      }}
    >
      <Header />
      <div className="content_container" style={{ flex: 1, minHeight: "100%" }}>
        <Outlet />
      </div>
      <Footer />
      <IconButton
        onClick={scrollToTop}
        sx={{
          position: "fixed",
          bottom: "3%",
          right: "3%",
          height: "35px",
          width: "35px",
          background: "black",
          borderRadius: "6px",
          ":hover": {
            background: "black",
          },
        }}
      >
        <ArrowDropUpIcon sx={{ color: "white" }} />
      </IconButton>
    </div>
  );
};

export default BaseLayout;
